/**
 * DetailLevelStep — Step 4: Radio list of L1-L5 tiers.
 */

import { T } from '@/styles/tokens';
import { TIER_KEYS, TIERS } from '@/types/tier';
import type { TierKey } from '@/types/tier';
import { StepNextButton } from './StepNextButton';
import { SectionIcon } from './SectionIcons';

const cardStyle: React.CSSProperties = {
  background: T.white,
  borderRadius: 16,
  border: `1px solid ${T.cream200}`,
  padding: 24,
  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
};

interface DetailLevelStepProps {
  tier: TierKey;
  onChangeTier: (tier: TierKey) => void;
  onNext: () => void;
}

export function DetailLevelStep({ tier, onChangeTier, onNext }: DetailLevelStepProps) {
  return (
    <div>
      <SectionIcon icon="detail" label="Detail Level" />
      <div style={cardStyle}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {TIER_KEYS.map((k) => {
            const sel = k === tier;
            const t = TIERS[k];
            return (
              <button
                key={k}
                onClick={() => onChangeTier(k)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '12px 14px',
                  borderRadius: 12,
                  border: `1.5px solid ${sel ? T.primary : T.border}`,
                  background: sel ? T.tealSoft : T.white,
                  cursor: 'pointer',
                  transition: 'all 0.12s ease',
                  textAlign: 'left',
                  fontFamily: T.fontFamily,
                }}
              >
                {/* Radio indicator */}
                <div style={{
                  width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                  border: `2px solid ${sel ? T.primary : T.charcoal200}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'all 0.12s ease',
                }}>
                  {sel && <div style={{ width: 10, height: 10, borderRadius: '50%', background: T.primary }} />}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: sel ? T.primaryDark : T.text, fontFamily: T.fontFamily, lineHeight: 1.3 }}>
                    {t.label}
                  </div>
                  <div style={{ fontSize: 12, color: T.charcoal400, fontFamily: T.fontFamily, lineHeight: 1.4, marginTop: 1 }}>
                    {t.description}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
        <StepNextButton label="Next" disabled={false} onPress={onNext} />
      </div>
    </div>
  );
}
